import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteContractEvent: { id: string }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.deleteContractEvent.id,
  name: 'Contract',
})

export default function deleteEvent(eventId: string) {
  return client.gql
    .mutate({
      mutation: deleteContractEventMutation,
      variables: { input: { id: eventId } },
    })
    .then(mutateHandler)
}

const deleteContractEventMutation = gql`
  mutation deleteEvent($input: DeleteContractEventInput!) {
    deleteContractEvent(input: $input) {
      contractEvent {
        id
      }
    }
  }
`
